
import { observable, action } from "mobx";
import firebase from "../config/firebaseInit";
import Avatar from "../assets/images/avatar.jpg";

class AvatarStore {

    @observable pathToImage;

    constructor(pathToImage) {
        this.pathToImage = pathToImage;
    }

    @action
    setPathImage(path) {
        this.pathToImage = path;
    }
}
let avatarStore=new AvatarStore(Avatar);
firebase.auth().onAuthStateChanged(function (user) {
    if (user) {
        // User is signed in.
        avatarStore.setPathImage(user.photoURL);

    } 
});

export default avatarStore;